module.exports = __webpack_public_path__ + "media/music/57f0f65052d9dac78ee66b11cc696b6a.mp3";